import React from 'react';
import { Button, Modal } from '@seismic/mantle';
import styles from '../Footer.scss';
import contentStyles from './DeleteConfirmationModal.scss';

interface Props {
  isOpen: boolean;
  header: string;
  description: string;
  acceptButtonText: string;
  onAccept: () => void;
  onReject: () => void;
}

export default function DeleteConfirmationModal(props: Props) {
  const getHeader = (id: string) => {
    return (
      <span id={id} className={contentStyles.header} data-testid="header">
        {props.header}
      </span>
    );
  };

  const getFooter = () => {
    return (
      <div className={styles.footer} data-testid="footer">
        <Button
          data-testid="cancel-button"
          className={styles.cancelButton}
          variant="tertiary"
          label="Cancel"
          onClick={props.onReject}
        />
        <Button
          data-testid="confirm-delete"
          variant="warning"
          label={props.acceptButtonText}
          onClick={props.onAccept}
        />
      </div>
    );
  };

  return (
    <Modal
      data-testid="deleteConfirmModal"
      className={contentStyles.deleteConfirmationModal}
      onClose={props.onAccept}
      open={props.isOpen}
      header={getHeader}
      displayCloseButton={false}
      footer={getFooter()}
    >
      <span className={contentStyles.description} data-testid="description">
        {props.description}
      </span>
    </Modal>
  );
}
